import DateTimeUtils from '../../../utils/date_time_utils';
import RestrictionMessages from '../messages/restriction_messages';
import ServiceFactory from '../../service_factory';
import IRestrictionMessages from '../messages/restriction_messages_interface';
import BaseObject from '../../../base/base_object';
import IRestrictionValueBase from './restriction_value_base_interface';

const RESTRICTION_REASONS = {
  SESSION_LIMIT_REACHED: '8'
};

const RESTRICTION_ACTIONS = {
  PLAY: '3',
  OPEN_APPLICATION: '4'
};


export default class GenericRestrictionValue extends BaseObject implements IRestrictionValueBase {
  static CLASS = 'GenericRestrictionValue';
  private _serviceFactory: ServiceFactory = null;
  private _actionId: string;
  private _reasonId: string;
  private _value: string;
  private _expirationDate: number|Date;


  init(params) {
    super.init(params);
    this._serviceFactory = params.serviceFactory;
    this._createRestrictionMessage = params.createRestrictionMessage || this._createRestrictionMessage;

    this._actionId = params.actionId.toString();
    this._reasonId = params.restrictionData.ReasonId && params.restrictionData.ReasonId.toString();
    this._value = params.restrictionData.Value && params.restrictionData.Value.toString().toLowerCase();
    if(params.restrictionData.SecondsToExpire) {
      this._expirationDate =  this._serviceFactory.timeService().now() + DateTimeUtils.secondsToMilliseconds(params.restrictionData.SecondsToExpire);
    } else if(params.restrictionData.ExpirationDate) {
      this._expirationDate = this._serviceFactory.timeService().parseDate(params.restrictionData.ExpirationDate);
    }

  }


  public isExpired(): boolean {
    if(!this._expirationDate) {
      return false;
    }

    return this._expirationDate < this._serviceFactory.timeService().now();
  }

  public isGameAllowedInTheGrid(): boolean {
    return this.isExpired()
      || this._reasonId === RESTRICTION_REASONS.SESSION_LIMIT_REACHED
      || this._value === 'all';
  }

  public isGameAllowedToPlayReal(): boolean {
    return this.isExpired();
  }

  public isActiveRestrictionForOpenApplication(): boolean {
    return !this.isExpired() && this._actionId === RESTRICTION_ACTIONS.OPEN_APPLICATION;
  }

  private _createRestrictionMessage(): IRestrictionMessages {
    return RestrictionMessages.create({
      serviceFactory: this._serviceFactory
    });
  }

  public showUserMessage(): void {
    const restrictionMessages = this._createRestrictionMessage();
    if(this._reasonId === RESTRICTION_REASONS.SESSION_LIMIT_REACHED) {
      restrictionMessages.showSessionLimitMessage(this._expirationDate);
    } else {
      restrictionMessages.showGenericMessage();
    }
  }
}